import dayjs from 'dayjs'

// 日期格式化
export const formatDate = (date: string | Date, format = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(date).format(format)
}

export const formatDateTime = (date: string | Date) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
}

export const formatDateOnly = (date: string | Date) => {
  return dayjs(date).format('YYYY-MM-DD')
}

export const formatTime = (date: string | Date) => {
  return dayjs(date).format('HH:mm:ss')
}

// 数字格式化
export const formatNumber = (num: number, decimals = 0) => {
  return num.toLocaleString('zh-CN', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })
}

// 文件大小格式化
export const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 B'
  
  const k = 1024
  const sizes = ['B', 'KB', 'MB', 'GB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

// 状态文本格式化
export const formatStatus = (status: string) => {
  const statusMap: Record<string, string> = {
    unpacked: '未装箱',
    packing: '装箱中',
    completed: '已完成',
    unpacked_partial: '部分装箱',
    active: '启用',
    inactive: '禁用',
  }
  
  return statusMap[status] || status
}

// 角色名称格式化
export const formatRole = (role: string) => {
  const roleMap: Record<string, string> = {
    admin: '管理员',
    business: '业务员',
    packer: '装箱员',
  }
  
  return roleMap[role] || role
}